import React from "react";
import type { TransformedProduct } from "../../../../../types/productApiTypes";
import GroupedProductList from "./GroupedProductList";

interface GroupedProductContentProps {
  product: TransformedProduct;
}

const GroupedProductContent: React.FC<GroupedProductContentProps> = ({
  product,
}) => {
  return (
    <div className="grouped-product-content">
      {product.description && (
        <div
          className="grouped-product-content__description"
          dangerouslySetInnerHTML={{ __html: product.description }}
        />
      )}
      <GroupedProductList productIds={product.groupedProductIds} />
    </div>
  );
};

export default GroupedProductContent;
